import React from 'react';
import cx from 'classnames';

import Avatar1 from './utils/images/ava01.png';
import Avatar2 from './utils/images/ava02.png';
import Avatar3 from './utils/images/ava03.png';
import Avatar4 from './utils/images/ava04.png';
import Avatar5 from './utils/images/ava05.png';
import Avatar6 from './utils/images/ava06.png';
import Avatar7 from './utils/images/ava07.png';
import Avatar8 from './utils/images/ava08.png';
import Avatar9 from './utils/images/ava09.png';
import Avatar10 from './utils/images/ava10.png';
import Avatar11 from './utils/images/ava11.png';
import Avatar12 from './utils/images/ava12.png';

interface OwnerAvatarProps {
  size: string;
  address: string;
  colorized?: boolean;
  styleWrapper?: string;
  styleImage?: string;
  index?: number;
}

const avatarArray = [
  Avatar1,
  Avatar2,
  Avatar3,
  Avatar4,
  Avatar5,
  Avatar6,
  Avatar7,
  Avatar8,
  Avatar9,
  Avatar10,
  Avatar11,
  Avatar12,
];

export const OwnerAvatar: React.FC<OwnerAvatarProps> = ({
  size,
  colorized = true,
  address,
  styleWrapper,
  styleImage,
  index = -1,
}) => {
  const getIconByAddress = () => {
    if (index >= 0) {
      return avatarArray[index % 12];
    }
    if (!Boolean(address)) {
      return avatarArray[0];
    }

    const str = address.replace('0x', '').replace('.', '');
    if (str.length < 5) {
      return avatarArray[
        isNaN(parseInt(str, 16) % avatarArray.length) ? 1 : parseInt(str, 16) % avatarArray.length
      ];
    }

    return avatarArray[
      isNaN(parseInt(str.substring(str.length - 5), 16) % avatarArray.length)
        ? 0
        : parseInt(str.substring(str.length - 5), 16) % avatarArray.length
    ];
  };

  return (
    <div className={cx('flex items-center justify-center rounded-[50%]', styleWrapper)}>
      <img
        src={getIconByAddress()}
        className={cx('max-w-[100%] max-h-[100%]', styleImage)}
        style={{ width: size, height: size }}
        alt=""
      />
    </div>
  );
};
